import { Box, ButtonBase } from "@mui/material";
import colors from "../../config/colors";
import { colorPalette } from "../../config/colorPalette";
import { ELEVATION } from "../../config/shadows";

/**
 * Menu
 *
 * The menu panel only. Show it inside a MUI Popover / Popper (or anywhere) yourself.
 *
 * Props:
 * - items: [{ label, onClick?, tone?: "danger", disabled?, selected? } | { divider: true }]
 *   (selected marks the current choice: a tint and medium weight)
 * - sx: extra styles for the panel, merged last
 */
const Menu = ({ items = [], sx: sxOverride = {}, ...rest }) => (
  <Box
    role="menu"
    {...rest}
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      minWidth: 220,
      padding: "3px", // Figma's 4px, less the 1px border
      boxSizing: "border-box",
      borderRadius: "8px",
      backgroundColor: colors.white,
      border: `1px solid ${colorPalette.mercuryAlpha[8]}`,
      boxShadow: ELEVATION,
      ...sxOverride,
    }}
  >
    {items.map((item, index) =>
      item.divider ? (
        <Box
          key={`divider-${index}`}
          role="separator"
          sx={{ height: "1px", backgroundColor: colorPalette.mercuryAlpha[8] }}
        />
      ) : (
        <ButtonBase
          key={`${item.label}-${index}`}
          role="menuitem"
          disabled={item.disabled}
          onClick={item.onClick}
          sx={{
            justifyContent: "flex-start",
            padding: "8px 12px",
            borderRadius: "4px",
            fontFamily: '"Lexend", sans-serif',
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: item.selected ? 500 : 400,
            lineHeight: 1.45,
            letterSpacing: "0.1px",
            textAlign: "left",
            backgroundColor: item.selected
              ? colorPalette.mercuryAlpha[5]
              : undefined,
            color:
              item.tone === "danger"
                ? colorPalette.red[700]
                : colorPalette.mercury[950],
            "&:hover": { backgroundColor: colorPalette.mercuryAlpha[5] },
            "&.Mui-disabled": { opacity: 0.4 },
          }}
        >
          {item.label}
        </ButtonBase>
      ),
    )}
  </Box>
);

export default Menu;
